import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { ChangeCellularModePayload, ChangeCellularModeResponse } from '@/api/device/types';
import { refreshCachedDevice } from '@/api/devices';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';
import { useErrorContext } from '@/context/ErrorContext';

export const changeCellularMode = (props: ChangeCellularModePayload): Promise<ChangeCellularModeResponse> => {
    const { spotterId, ...payload } = props;
    return axios.patch(`/user-rest/devices/${spotterId}/cellular-settings`, payload);
};

type UseChangeCellularModeOptions = {
    config?: MutationConfig<typeof changeCellularMode>;
    data?: ChangeCellularModePayload;
};

export const useChangeCellularMode = ({ config }: UseChangeCellularModeOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: changeCellularMode,
        onSuccess: (_data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Device cellular mode changed', {
                spotterId: variables.spotterId,
                processingRateMins: variables.processingRateMins,
                hdrEnabled: variables.hdrEnabled,
            });
        },
        onError: createErrorHandler('change cellular data mode'),
    });
};
